import {StyledAgendaSidebarDottedDivider} from '@/features/agenda/components/agenda-sidebar-dotted-divider/style'

export const AgendaSidebarDottedDivider = () => {
    return <StyledAgendaSidebarDottedDivider />
}
